<style lang="scss" scoped>
.social {
  display: inline-block;
  margin-bottom: 0.5rem;
}

.social-child {
  float: left;
  padding-right: 20px;
}
</style>

<template>
  <div class="social">
    <div class="social-child">
      <a
        class="twitter-share-button"
        :href="`https://twitter.com/intent/tweet?url=${fullpath}`"
        target="_blank"
      >
        <b-icon icon="twitter" />{{ $t('tweet') }}</a
      >
    </div>
    <div class="social-child">
      <a
        class="fb-share-button"
        :href="`https://www.facebook.com/share.php?u=${fullpath}`"
        target="_blank"
      >
        <b-icon icon="facebook" />{{ $t('share') }}
      </a>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  setup() {
    const fullpath = window.location;
    return { fullpath };
  }
});
</script>
